// extracted by mini-css-extract-plugin
export default {"component":"externalEmployeeDialog__component___pWKYD"};